import { FC } from 'react'
import LazyLoad from 'react-lazyload'
import AllFeatureSection from '~/components/LandingPage/AllFeatureSection'
import AllPlatformSection from '~/components/LandingPage/AllPlatformSection'
import EffectiveSection from '~/components/LandingPage/EffectiveSection'
import JourneySection from '~/components/LandingPage/JourneySection'
// import ReviewSection from '~/components/LandingPage/ReviewSection'
import SolutionsSection from '~/components/LandingPage/SolutionsSection'
import UseCasesSection from '~/components/LandingPage/UseCasesSection'
import LayoutLandingPage from '~/components/Layout/LayoutLandingPage'

const LazyLoadWrapper = LazyLoad as unknown as FC<any>

const LandingPageContainer: FC = () => {
  return (
    <>
      <LayoutLandingPage animationOffset={1000}>
        <EffectiveSection />

        <LazyLoadWrapper height={300} once>
          <AllFeatureSection />
        </LazyLoadWrapper>

        <LazyLoadWrapper height={300} once>
          <AllPlatformSection />
        </LazyLoadWrapper>

        <LazyLoadWrapper height={300} once>
          <UseCasesSection />
        </LazyLoadWrapper>

        <LazyLoadWrapper height={300} once>
          <SolutionsSection />
        </LazyLoadWrapper>

        {/* <LazyLoad height={300} once>
          <ReviewSection />
        </LazyLoad> */}

        <LazyLoadWrapper height={300} once>
          <JourneySection className="desktop:mt-[140px] desktop:mb-[0px] bg-gray-50 mt-[64px] my-[0px] py-[64px]" />
        </LazyLoadWrapper>
      </LayoutLandingPage>
    </>
  )
}

export default LandingPageContainer
